import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useWindowSize } from '../../../Hooks/use-window-size';

import { getSidebarEntries } from './side-bar.config';
import { openActiveSections, getInitiallyOpenSections } from './side-bar.matchers';
import { RootSidebarLink } from './side-bar-link';
import { SidebarSection } from './side-bar-section';
import './side-bar.scss';

export function AdminSideBar() {
  const location = useLocation();
  const { width } = useWindowSize();
  const adminId = Cookies.get('adminID');
  const isSuperAdmin = adminId === '1';
  const entries = getSidebarEntries(isSuperAdmin);
  const isDesktop = width > 768;

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openSections, setOpenSections] = useState<Record<string, boolean>>(() =>
    getInitiallyOpenSections(entries, location.pathname),
  );

  useEffect(() => {
    setOpenSections((currentState) =>
      openActiveSections(currentState, entries, location.pathname),
    );
  }, [entries, location.pathname]);

  function toggleSection(sectionId: string) {
    setOpenSections((currentState) => ({
      ...currentState,
      [sectionId]: !currentState[sectionId],
    }));
  }

  function handleNavigate() {
    if (!isDesktop) {
      setIsMobileMenuOpen(false);
    }
  }

  const shouldRenderSidebar = isDesktop || isMobileMenuOpen;

  return (
    <div className='admin-side-bar'>
      {!isDesktop ? (
        <div className='admin-side-bar__mobile-toggle'>
          <button
            className='admin-side-bar__mobile-button'
            onClick={() => setIsMobileMenuOpen((currentState) => !currentState)}
            type='button'
          >
            <span>Admin menu</span>
            {isMobileMenuOpen ? <RemoveIcon /> : <AddIcon />}
          </button>
        </div>
      ) : null}

      {shouldRenderSidebar ? (
        <div className='Sidebar'>
          <ul className='SidebarList'>
            {entries.map((entry) =>
              entry.type === 'link' ? (
                <RootSidebarLink
                  entry={entry}
                  key={entry.id}
                  onNavigate={handleNavigate}
                  pathname={location.pathname}
                />
              ) : (
                <SidebarSection
                  isOpen={Boolean(openSections[entry.id])}
                  key={entry.id}
                  onNavigate={handleNavigate}
                  onToggle={() => toggleSection(entry.id)}
                  pathname={location.pathname}
                  section={entry}
                />
              ),
            )}
          </ul>
        </div>
      ) : null}
    </div>
  );
}

export default AdminSideBar;
